import { jwtDecode } from 'jwt-decode';

export const manualRefreshToken = async () => {
	if (window.IIRISProfileMgr) {
		const auth_token = beaconGetIIRISCookie('IRIS_AUTH');
		const passToken = beaconGetIIRISCookie('IRIS_HASH');
		const decodedToken = jwtDecode(auth_token);
		const clientId = (decodedToken as any)?.client_id;
		try {
			await window.IIRISProfileMgr.getRefreshedAuth(
				clientId,
				passToken,
				window.IIRISProfileMgr.setIIRISCookie,
				beaconGetIIRISCookie
			);
		} catch (error) {
			console.log(error);
		}
	}
};

export function beaconGetIIRISCookie(cname: string) {
	let name = cname + '=';
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}
